import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    ContractReferenceRequest,
    ContractReferenceMonthSnapshot,
} from '../../models/RentalPayment';
import api from '../api';

const getContractReference = (
    request: ContractReferenceRequest
): Promise<ContractReferenceMonthSnapshot[]> => {
    const params = decamelizeKeys(request) as Record<string, string>;
    return api.request<ContractReferenceMonthSnapshot[]>({
        method: 'GET',
        params,
        url: `${getBackVersion()}/agent/rental/contract_reference`,
    });
};

export { getContractReference };
